import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import { fetchAppSettings } from 'src/api/dashboard'

const initialAppState = {
  sidebarShow: true,
  sidebarUnfoldable: true,
  loginFlag: false,
  userToken: null,
  userNameRedux: localStorage.getItem('userName'),
  digestValueRedux: '',
  timeZoneValue: localStorage.getItem('timeZone'),
  isAzureAdLoginEnabled: false,
  isFirmwareUpdateFileUploadEnabled: false,
  impersonationToken: null,
  loading: false,
  settings: null,
}

export const loadAppSettings = createAsyncThunk(
  'app/loadAppSettings',
  async (_, { rejectWithValue }) => {
    try {
      const res = await fetchAppSettings()
      return res.data.data
    } catch (error) {
      return rejectWithValue(error.response?.data || 'Something went wrong')
    }
  },
)

const appSlice = createSlice({
  name: 'app',
  initialState: initialAppState,
  reducers: {
    appSideBarHandler(state, action) {
      state.sidebarShow = action.payload
    },
    appSideBarUnfoldableHandler(state, action) {
      state.sidebarUnfoldable = action.payload
    },
    loginFlaghandler(state, action) {
      state.loginFlag = action.payload
    },
    userToken(state, action) {
      state.userToken = action.payload
    },
    userNameHandler(state, action) {
      state.userNameRedux = action.payload
    },
    digestValueHandler(state, action) {
      state.digestValueRedux = action.payload
    },
    timeZoneHandler(state, action) {
      state.timeZoneValue = action.payload
    },
    appSettingsHandler(state, action) {
      state.isAzureAdLoginEnabled = action?.payload?.isAzureAdLoginEnabled
      state.isFirmwareUpdateFileUploadEnabled = action?.payload?.isFirmwareUpdateFileUploadEnabled
    },
    setImpersonationTokenHandler(state, action) {
      state.impersonationToken = action.payload
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(loadAppSettings.pending, (state) => {
        state.loading = true
      })
      .addCase(loadAppSettings.fulfilled, (state, action) => {
        state.settings = action.payload
        state.loading = false
      })
      .addCase(loadAppSettings.rejected, (state) => {
        state.loading = false
      })
  },
})

export const appActions = appSlice.actions
export default appSlice.reducer
